module.exports = __webpack_public_path__ + "static/media/Chiller_updated_img.3908b198.jpg";